import React from "react";

function TabellaDanzaNuova() {
    return(
        <div className="table-container">
            <table className="table m-auto" style={{width: "90%"}}>
                <colgroup>
                    <col style={{ width: "16.666%", minWidth: "100px"}} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                </colgroup>
                <thead>
                <tr>
                    <th className="text-center" scope="col">Lun</th>
                    <th className="text-center" scope="col">Mar</th>
                    <th className="text-center" scope="col">Mer</th>
                    <th className="text-center" scope="col">Gio</th>
                    <th className="text-center" scope="col">Ven</th>
                    <th className="text-center" scope="col">Sab</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                    <td className="text-center">
                        14:30 - 16:00<br/><strong>Classico avanzato</strong><br/><span>11-15 anni</span>
                    </td>
                    <td className="text-center"></td>
                    <td className="text-center">
                        9:15 - 10:15<br/><strong>Classico Propedeutica</strong><br/>4-9 anni
                    </td>
                </tr>
                <tr>
                    <td className="text-center">
                        17:00 - 18:00<br/><strong>Cheerleading Intermedio*</strong><br/>7-15 anni
                    </td>
                    <td className="text-center">
                        16:45 - 17:45 <br/> <strong>Contemporaneo Intermedio - Open</strong><br/>10-15 anni
                    </td>
                    <td className="text-center">
                        17:00 - 18:00 <br/> <strong>Mini Modern</strong><br/>4-7 anni
                    </td>
                    <td className="text-center">
                        17:00 - 18:00<br/><strong>Cheerleading Intermedio*</strong><br/>7-15 anni
                    </td>
                    <td className="text-center">
                        16:45 - 17:45 <br/> <strong>Contemporanea Intermedio - Open </strong><br/>10-15 anni
                    </td>
                    <td className="text-center">
                        10:30 - 11:30<br/><strong>Modern Piccoli</strong><br/>4-9 anni
                    </td>
                </tr>
                <tr>
                    <td className="text-center">
                        18:00 - 19:00 <br/> <strong>International Intermedio*</strong><br/>8-13 anni
                    </td>
                    <td className="text-center">
                        17:45 - 18:45<br/><strong>Experience avanzato*</strong><br/>11-15 anni
                    </td>
                    <td className="text-center">18:00 - 19:00<br/><strong>Contemporaneo base</strong><br/>7-13 anni<br/><div style={{fontSize: "12px"}}></div>
                    </td>
                    <td className="text-center">
                        18:00 - 19:00 <br/> <strong>International Intermedio*</strong><br/>8-13 anni
                    </td>
                    <td className="text-center">
                        17:45 - 18:45<br/><strong>Experience avanzato*</strong><br/>11-15 anni
                    </td>
                    <td className="text-center">
                        11:30 - 12:30<br/><strong>Hip Hop</strong><br/>10-15 anni
                    </td>
                </tr>
                <tr>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                    <td className="text-center">19:15 - 20:15<br/> <strong>Sbarra a terra e stretching</strong><br/>10-15 anni</td>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaDanzaNuova;
